import { Node, mergeAttributes } from '@tiptap/core';

export const EditorVideo = Node.create({
    name: 'video',
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
        return {
            src: { default: null },
            controls: { default: true },
            preload: { default: 'metadata' },
        };
    },

    parseHTML() {
        return [{ tag: 'video' }];
    },

    renderHTML({ HTMLAttributes }) {
        const rest = { ...HTMLAttributes };
        delete rest.autoplay;
        return [
            'video',
            mergeAttributes(rest, {
                controls: 'true',
                preload: 'metadata',
                class: 'task-content-video',
                playsinline: 'true',
            }),
        ];
    },
});
